"use strict";
var PairsObservable_1 = require('./PairsObservable');
exports.pairs = PairsObservable_1.PairsObservable.create;
//# sourceMappingURL=pairs.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/observable/pairs.js
 ** module id = 116
 ** module chunks = 2
 **/